export default "__VITE_ASSET__C2HW6Qnp__"